// extracted by mini-css-extract-plugin
export default {"title":"Header_title__CM6Vn","text":"Header_text__C0zeZ"};